import { apiClient } from "./apiClient";

export interface AgencyRefConflict {
  /** "LE" for Legal Entity, "BR" for Branch. */
  kind: "LE" | "BR";
  id: string;
  name: string;
}

export interface AgencyRefCheckResponse {
  duplicate: boolean;
  conflict?: AgencyRefConflict | null;
}

/**
 * Endpoints for the CRM Integration / Configuration page. The agency-ref
 * uniqueness check returns whether the supplied {@code ref} is already used
 * by another LE or Branch under the same {@code sourceCrm} within the
 * same legal entity hierarchy. When {@code legalEntityId} is provided, the
 * check is scoped to the root hierarchy; otherwise it falls back to a
 * global check for backward compatibility.
 */
export const integrationsService = {
  checkAgencyRef: (params: {
    sourceCrm: string;
    ref: string;
    excludeKind?: "LE" | "BR";
    excludeId?: string;
    legalEntityId?: string;
  }): Promise<AgencyRefCheckResponse> =>
    apiClient
      .get<AgencyRefCheckResponse>("/integrations/agency-ref/check", {
        params: {
          sourceCrm: params.sourceCrm,
          ref: params.ref,
          ...(params.excludeKind ? { excludeKind: params.excludeKind } : {}),
          ...(params.excludeId ? { excludeId: params.excludeId } : {}),
          ...(params.legalEntityId
            ? { legalEntityId: params.legalEntityId }
            : {}),
        },
      })
      .then((r) => r.data),
};